module.exports = __webpack_public_path__ + "static/media/banner-newgames-mobile.2c4c1cf1.jpg";